import Img from '../../assets/img/bitrixTooltip/bitrix1.png';
import Img2 from '../../assets/img/bitrixTooltipChatBot/bitrixChatbot1.png';
import Img3 from '../../assets/img/bitrixTooltipChatBot/bitrixChatbot2.png';
import Img4 from '../../assets/img/bitrixTooltip/bitrix4.png';
import Img5 from '../../assets/img/bitrixTooltipChatBot/bitrixChatbot3.png';
import Img6 from '../../assets/img/bitrixTooltipChatBot/bitrixChatbot4.png';
import Img7 from '../../assets/img/bitrixTooltipChatBot/bitrixChatbot5.png';

import styles from '../../ui/Tooltip/Tooltip.module.scss';

export const stepsDataBitrixChatBot = [
    {
        title: 'Перейдите в “Rest API“',
        description: (
            <ul className={styles.ulListContainer}>
                <li>Необходимо совершить вход в Битрикс24.</li>
                <li>Перейти в раздел CRM.</li>
                <li>
                    В верхнем меню выбрать «Еще» - «Интеграции» - «Rest API».
                </li>
            </ul>
        ),
        imgSrc: Img,
    },
    {
        title: 'Перейдите в раздел “Добавить чат-бот”',
        description: (
            <ul className={styles.ulListContainer}>
                <li>В открывшемся блоке выберите раздел “Добавить чат-бот”.</li>
                <li>Нажмите на этот пункт.</li>
            </ul>
        ),
        imgSrc: Img2,
    },
    {
        title: 'Перейдите в раздел “Информировать сотрудников в чате”',
        description: (
            <ul className={styles.ulListContainer}>
                <li>
                    В открывшемся блоке выберите раздел “Информировать
                    сотрудников в чате”.
                </li>
                <li>Нажмите на этот пункт.</li>
            </ul>
        ),
        imgSrc: Img3,
    },
    {
        title: 'Скопируйте “Вебхук для вызова rest api”',
        description: (
            <ul className={styles.ulListContainer}>
                <li>
                    На появившейся странице будет возможность переименовать
                    интеграцию, введите любое название, которое потом можно
                    идентифицировать с интеграцией ИИ ассистента в Битрикс24.
                </li>
                <li>
                    Необходимо скопировать полностью адрес, который будет указан
                    в поле «Вэбхук для вызова rest api» и скопировать.
                </li>
            </ul>
        ),
        imgSrc: Img4,
    },
    {
        title: 'В блоке “Создание бота” заполните все данные.',
        description: (
            <ul className={styles.ulListContainer}>
                <li>Введите имя бота, которое будет отображаться в чате.</li>
                <li>
                    URL обработчик бота - это ссылка на ваше мини-приложение.
                </li>
                <li>Выберите подходящий тип бота.</li>
                <li>Нажмите кнопку «Создать бота».</li>
            </ul>
        ),
        imgSrc: Img5,
    },
    {
        title: 'Блок “Генератор запросов” не изменяйте.',
        description: (
            <ul className={styles.ulListContainer}>
                <li>
                    Блок «Генератор запросов» автоматически заполняется после
                    создания бота.
                </li>
                <li>Скопируйте «BOT_ID» и «CLIENT_ID»</li>
            </ul>
        ),
        imgSrc: Img6,
    },
    {
        title: 'Предоставьте права',
        description: (
            <ul className={styles.ulListContainer}>
                <li>
                    Необходимо предоставить права, как показаны на скриншоте.
                </li>
                <li>Нажмите кнопку «Сохранить»</li>
            </ul>
        ),
        imgSrc: Img7,
    },
];
